import React from "react";
import { useState } from "react";
import { Subscribe } from "unstated";
import { useTranslation } from "react-i18next";

import StateContainer from "../../../state/StateContainer";
import stringHelper from "../../../utils/helpers/stringHelper";
import deviceHelper from "../../../utils/helpers/deviceHelper";

function StarButton(props) {
  const [isIconHovered, setIsIconHovered] = useState(false);

  const { isStatic } = props; // The icon will not be clickable
  const { t } = useTranslation();

  const isMobile = deviceHelper.isMobileDevice();

  const styles = {
    iconColor: isIconHovered ? props.unstated.state.menuColor : "#FFFFFF",
    opacity: isIconHovered ? 1 : 0.6,
    backgroundColor: isStatic
      ? props.unstated.state.menuColor
      : props.unstated.state.menuColorSecondary,
    size: isStatic ? "50px" : "45px",
    cursor: isStatic ? "default" : "pointer",
  };

  function clickHandler() {
    if (isStatic) return;
    props.unstated.handleShowElement("compareFavouritesView", true);
  }

  function onMouseEnter() {
    if (isStatic) return;
    setIsIconHovered(true);
  }

  function onMouseLeave() {
    if (isStatic) return;
    setIsIconHovered(false);
  }

  return (
    <div
      onClick={clickHandler}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className="star-icon"
      style={{
        backgroundColor: isMobile ? 
          stringHelper.removeAplhaFromColor(props.unstated.state.menuColorSecondary) : 
          props.unstated.state.menuColorSecondary,
        cursor: styles.cursor,
      }}
    >
      <svg
        fill={
          isStatic
            ? stringHelper.removeAplhaFromColor(props.unstated.state.menuColor)
            : styles.iconColor
        }
        style={{ marginTop: isStatic ? "5px" : "0" }}
        opacity={isStatic ? 1 : styles.opacity}
        width={styles.size}
        height={styles.size}
        viewBox="0 0 1920 1920"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1915.918 737.475c-10.955-33.543-42.014-56.131-77.364-56.131h-612.029l-189.063-582.1v-.112C1026.394 65.588 995.335 43 959.984 43c-35.237 0-66.41 22.588-77.365 56.245L693.443 681.344H81.415c-35.35 0-66.41 22.588-77.365 56.131-10.955 33.544.79 70.137 29.478 91.03l495.247 359.831-189.177 582.212c-10.955 33.657 1.13 70.25 29.817 90.918 14.23 10.278 30.946 15.487 47.66 15.487 16.716 0 33.432-5.21 47.775-15.6l495.134-359.718 495.021 359.718c28.574 20.781 67.087 20.781 95.662.113 28.687-20.668 40.658-57.261 29.703-91.03l-189.176-582.1 495.36-359.83c28.574-20.894 40.433-57.487 29.364-91.03"
          fill-rule="evenodd"
        />
      </svg>
      <p
        style={{ opacity: isStatic ? 1 : styles.opacity }}
        className="star-icon-text"
      >
        {t("FAVORITES").toUpperCase()}
      </p>
    </div>
  );
}

function StarButtonWithUnstated(props) {
  return (
    <Subscribe to={[StateContainer]}>
      {(unstated) => <StarButton {...props} unstated={unstated} />}
    </Subscribe>
  );
}

export default StarButtonWithUnstated;
